module.exports = __webpack_public_path__ + "static/media/united-kingdom-icon.89732edb.svg";